import { existsSync, readFileSync } from 'fs';
import { join } from 'path';

export interface FrameworkInfo {
  isNextJs: boolean;
  version?: string;
  isAppRouter: boolean;
  hasSrcDir: boolean;
  hasTypeScript: boolean;
  hasTailwind: boolean;
}

export async function detectFramework(): Promise<FrameworkInfo> {
  const cwd = process.cwd();
  
  // Check if it's a Next.js project
  const packageJsonPath = join(cwd, 'package.json');
  if (!existsSync(packageJsonPath)) {
    return {
      isNextJs: false,
      isAppRouter: false,
      hasSrcDir: false,
      hasTypeScript: false,
      hasTailwind: false,
    };
  }

  try {
    const packageJson = JSON.parse(readFileSync(packageJsonPath, 'utf-8'));
    const hasNext = !!(packageJson.dependencies?.next || packageJson.devDependencies?.next);
    
    if (!hasNext) {
      return {
        isNextJs: false,
        isAppRouter: false,
        hasSrcDir: false,
        hasTypeScript: false,
        hasTailwind: false,
      };
    }

    // Get Next.js version
    const version = packageJson.dependencies?.next || packageJson.devDependencies?.next;
    const versionNumber = version.replace(/[\^~]/, '');

    // Detect router type
    const hasAppDir = existsSync(join(cwd, 'app')) || existsSync(join(cwd, 'src/app'));
    const hasPagesDir = existsSync(join(cwd, 'pages')) || existsSync(join(cwd, 'src/pages'));
    
    // Prefer App Router if both exist
    const isAppRouter = hasAppDir;

    // Check for src directory
    const hasSrcDir = existsSync(join(cwd, 'src'));

    // Check for TypeScript
    const hasTypeScript = existsSync(join(cwd, 'tsconfig.json'));

    // Check for Tailwind
    const hasTailwind = !!(packageJson.dependencies?.tailwindcss || packageJson.devDependencies?.tailwindcss);

    return {
      isNextJs: true,
      version: versionNumber,
      isAppRouter,
      hasSrcDir,
      hasTypeScript,
      hasTailwind,
    };
  } catch (error) {
    return {
      isNextJs: false,
      isAppRouter: false,
      hasSrcDir: false,
      hasTypeScript: false,
      hasTailwind: false,
    };
  }
}

export function getApiRoutePath(framework: FrameworkInfo): string {
  const base = framework.hasSrcDir ? 'src' : '';
  
  if (framework.isAppRouter) {
    return join(base, 'app', 'api');
  } else {
    return join(base, 'pages', 'api');
  }
}